import { EquipmentPurchasePlanStatus } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { EQUIPMENT_PURCHASE_PLAN_STATUS_LABEL_MAP } from 'noddi-util';
import { EQUIPMENT_PURCHASE_PLAN_STATUS_ICON } from './EquipmentStatusIcon';

const VARIANT_BY_STATUS = {
  [EquipmentPurchasePlanStatus.DRAFT]: 'outline',
  [EquipmentPurchasePlanStatus.PENDING_APPROVAL]: 'warning',
  [EquipmentPurchasePlanStatus.PURCHASING]: 'info',
  [EquipmentPurchasePlanStatus.RECEIVING]: 'warning',
  [EquipmentPurchasePlanStatus.COMPLETED]: 'success'
} as const;

export const EquipmentPurchasePlanStatusBadge = ({ status }: { status: EquipmentPurchasePlanStatus }) => (
  <NoddiBadge variant={VARIANT_BY_STATUS[status]}>
    <NoddiIcon name={EQUIPMENT_PURCHASE_PLAN_STATUS_ICON[status]} size='small' />
    {EQUIPMENT_PURCHASE_PLAN_STATUS_LABEL_MAP[status]}
  </NoddiBadge>
);
